import { useState } from 'react';
import './Categories.css';
import SubMenu from './SubCategories';
import { userVci } from '../../constants/const';

import styled from "styled-components";


export default function CategoriesMenuBar() {
    const [whichSub, SetWhichSub] = useState('');

    const visibleSub = event => {
        event.preventDefault();
        SetWhichSub(event.target.name);
    }
    return (
        <>
            {sessionStorage.getItem('token').includes(userVci) && <MainMenue>
                <MenueFirstLevel>
                    <MenueFirstLevelButton name="SD" onMouseEnter={visibleSub}>
                        Stammdaten
                    </MenueFirstLevelButton>
                    {whichSub === "SD" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
                </MenueFirstLevel>
            </MainMenue>}

            {sessionStorage.getItem('token').includes(userVci) && <MenueFirstLevel>
                <MenueFirstLevelButton name="JK" onMouseEnter={visibleSub}>
                    jährliche Kennzahlen
                </MenueFirstLevelButton>
                {whichSub === "JK" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel >}

            <MenueFirstLevel>
                <MenueFirstLevelButton name="DE" onMouseEnter={visibleSub}>
                    Datenerfassung
                </MenueFirstLevelButton>
                {whichSub === "DE" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel>

            {sessionStorage.getItem('token').includes(userVci) && <MenueFirstLevel>
                <MenueFirstLevelButton name="VB" onMouseEnter={visibleSub}>
                    vci Bereich
                </MenueFirstLevelButton>
                {whichSub === "VB" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel>
}
            <MenueFirstLevel>
                <MenueFirstLevelButton name="REP" onMouseEnter={visibleSub}>
                    Reporting
                </MenueFirstLevelButton>
                {whichSub === "REP" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel>

            <MenueFirstLevel>
                <MenueFirstLevelButton  name="BK" onMouseEnter={visibleSub}>
                    Benutzerkonto
                </MenueFirstLevelButton>
                {whichSub === "BK" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel>

            <MenueFirstLevel>
                <MenueFirstLevelButton name="SUP" onMouseEnter={visibleSub}>
                    Support
                </MenueFirstLevelButton>
                {whichSub === "SUP" && <SubMenu which={whichSub} setSub={SetWhichSub} />}
            </MenueFirstLevel>
        </>
    )
}

const MainMenue = styled.div`
    display: flex;
    flex-direction: row;

    &:first-child {
        border: none;
    }
`

const MenueFirstLevel = styled.div`
    display: flex;
    flex-direction: column;
    width: max-content;
    display: inline-block;
    position: relative;
`

const MenueFirstLevelButton = styled.button`
    width: 13em;
    height: 100%;

    text-align: center;
    font-weight: bold;
    font-size: 0.75em;
    background: none;
    border: none;
    border-left: 2px solid darkcyan;

    &:hover {
        text-decoration: none;
        background: rgba(32, 178, 171, 0.4);
    }
`